/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {adminSyncAuthzRelationshipPolicies} from '../api'

export const useMutationAdminSyncAuthzRelationshipPolicies = createReactQueryMutationHook('adminSyncAuthzRelationshipPolicies', adminSyncAuthzRelationshipPolicies)
